import { SimpleHandler, DictHandler, AnyHandler } from './../types/handlers';
import { Subject } from 'rxjs';
import { EventEmitter } from '@angular/core';

/**
 * Use instance of this class anywhere Subject subscriptiosn are happening
 * Takes care of maintaining the list of subscriptions and provides
 * an ability to cancel all the subscriptions in a single funciton call.
 */
export class SubscriptionMgr {
	private subscriptions: Array<any>;

	constructor() {
		this.subscriptions = [];
	}

	Subscribe(
		to: Subject<any> | EventEmitter<any>,
		ok?: AnyHandler | SimpleHandler | DictHandler,
		error?: AnyHandler | SimpleHandler | DictHandler
	) {
		this.subscriptions.push(to.subscribe(ok, error));
	}

	CancelSubscriptions() {
		for (const sub of this.subscriptions) {
			sub.unsubscribe();
		}
		this.subscriptions = [];
	}

}
